export const webAkteDataStructurePostProcessor = (payload) => {
    return {
        formInput: payload
    }
}